import React from "react";
import RSLayerControl from "./RSLayerControl";
import "./RemoteSensing.scss";
import * as helpers from "../../../helpers/helpers";

var mainConfig = "";

class MosaicsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      mosaicSelected: false,
      mosaicCode: null,
    };
  }

  componentDidMount() {
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      mainConfig = window.config;
      this.loadList();
    })
    
  }

  loadList = async () => {
    const apiUrl = mainConfig.apiUrlEsprit + "mosaics";
    const response = await fetch(apiUrl);
    const jsondata = await response.json();
    this.setState({ list: jsondata });
  };

  loadMosaic = (mosaicCode, fromDate, toDate) => {
    helpers.waitForLoad(["map"], Date.now(), 30, () => {
      window.emitter.emit("removeMosaicLayer");
      this.setState(
        {
          mosaicSelected: false,
          mosaicCode: "",
          dateFrom: "",
          dateTo: "",
        },
        () => {
          this.setState({
            mosaicSelected: true,
            mosaicCode: mosaicCode,
            dateFrom: fromDate,
            dateTo: toDate,
          });
        }
      );
    });
  };

  changeMosaicSelected = (bool) => {
    this.setState({
      mosaicSelected: bool,
    });
  };

  render() {
    let table_data = this.state.list.map((item) => {
      return (
        <tr key={item.id}>
          <td>{item.fromDate}</td>
          <td>{item.toDate}</td>
          <td>
            <button
              className="ui button btnAddMosaic"
              onClick={() =>
                this.loadMosaic(item.code, item.fromDate, item.toDate)
              }
              title="Pridať mozaiku"
            >
              +
            </button>
          </td>
        </tr>
      );
    });

    return (
      <>
        <div className="title-h2">Vybrať vrstvu z katalógu:</div>
        <div className="rs-table">
          <table className="ui celled table">
            <thead>
              <tr>
                <th>Dátum od</th>
                <th>Dátum do</th>
                <th>Pridať</th>
              </tr>
            </thead>
            <tbody>{table_data}</tbody>
          </table>
        </div>
        {this.state.mosaicSelected ? (
          <RSLayerControl
            mosaicCode={this.state.mosaicCode}
            dateFrom={this.state.dateFrom}
            dateTo={this.state.dateTo}
            onMosaicSelected={this.changeMosaicSelected}
          />
        ) : null}
      </>
    );
  }
}

export default MosaicsTable;
